import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles/";
import { Formik } from "formik";
import React, { useState } from "react";
import { Col, Modal, Row, Spinner } from "react-bootstrap";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { AppAPIService } from "../../../../services/AppAPIService";
import * as auth from "../../../../store/ducks/auth.duck";
import { IsValidPassword } from "../../../../utils/validators/IsValidPassword";
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons";
import styled from "styled-components";
import { FiArrowLeft, FiArrowRight, FiLock, FiX } from "react-icons/fi";
import "./style.scss";

const StyledModal = styled(Modal)`
  .modal-dialog {
    width: calc(100% - 32px);
    max-width: 560px;
    margin: auto;
  }

  .modal-content {
    overflow: hidden;
    margin: 0;
    border: 1px solid var(--xv-border);
    border-radius: var(--xv-radius);
    background: var(--xv-card);
    color: var(--xv-foreground);
    box-shadow: var(--xv-shadow-lg);
  }

  .modal-body {
    width: 100%;
    margin: 0;
    outline: none;
    padding: 0;
  }
`;

function ModalAlterPassword(props) {
  const { open, setOpen, result } = props;
  const api = AppAPIService.getInstance();
  const [loading, setLoading] = useState("");
  const { intl } = props;

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const useStyles = makeStyles(() => ({
    modalBody: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    },
    message: {
      fontSize: "1rem"
    },
    spinnerBorder: {
      width: "2rem",
      height: "2rem"
    }
  }));

  const classes = useStyles();

  return (
    <StyledModal
      show={open}
      onHide={() => setOpen(false)}
      centered
      className="xv-password-modal"
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Modal.Body>
        <div className="container-modal">
          <div className="xv-password-modal__header">
            <span className="xv-password-modal__icon" aria-hidden="true">
              <FiLock />
            </span>
            <div className="xv-password-modal__heading">
              <span>Segurança da conta</span>
              <h2 id="simple-modal-title">Alterar senha</h2>
              <p id="simple-modal-description">
                Defina uma nova senha para acessar o Portal Xavier.
              </p>
            </div>
            <button
              type="button"
              className="xv-password-modal__close"
              aria-label="Fechar"
              onClick={() => setOpen(false)}
            >
              <FiX />
            </button>
          </div>
          {loading ? (
            <div className={`${classes.modalBody} xv-password-modal__loading`}>
              <Row className="show-grid">
                <Col xs={12} md={12}>
                  <h3>Alterando senha...</h3>
                </Col>
              </Row>
              <Row className="show-grid">
                <Spinner
                  animation="border"
                  className={classes.spinnerBorder}
                  size="xs"
                />
              </Row>
            </div>
          ) : null}
          <Formik
            initialValues={{
              password: "",
              confirmPassword: "",
              newPassword: ""
            }}
            validate={values => {
              const errors = {};

              if (!values.password) {
                errors.password = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
              }

              if (!values.newPassword) {
                errors.newPassword = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
              } else if (IsValidPassword(values.newPassword) !== true) {
                errors.newPassword = "Senha não possui os requisitos mínimos:";
                IsValidPassword(values.newPassword).ERROS_FOUND.map(item => {
                  errors.newPassword +=
                    " /" +
                    intl.formatMessage({
                      id: "AUTH.VALIDATION." + item
                    });
                  return errors.newPassword;
                });
              }

              if (!values.confirmPassword) {
                errors.confirmPassword = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
              } else if (values.newPassword !== values.confirmPassword) {
                errors.confirmPassword =
                  "Senha e confirmação de senha não conferem.";
              }

              return errors;
            }}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              setLoading(true);
              const reqBase = { method: "PATCH", url: `/user/update-password/` };
              try {
                setLoading(true);
                const response = await api.makeHttpRequest({
                  ...reqBase,
                  data: {
                    currentPassword: values.password,
                    newPassword: values.newPassword
                  }
                });

                if (response) {
                  setLoading(false);
                  setSubmitting(false);
                  resetForm({});
                  result(true, "");
                }
              } catch (error) {
                // debugger;
                console.log(error.response);
                setLoading(false);
                setSubmitting(false);
                if (error.response && error.response.data) {
                  result(false, error.response.data.message);
                } else {
                  result(false, "Falha ao alterar a senha");
                }
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (
              <form
                className="xv-password-form"
                onSubmit={handleSubmit}
                noValidate
                autoComplete="off"
              >
                <div className="xv-password-form__field">
                  <TextField
                    type={showCurrentPassword ? "text" : "password"}
                    variant="outlined"
                    fullWidth
                    label="Senha Atual"
                    className="input-modal-update-password"
                    name="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    helperText={touched.password && errors.password}
                    error={Boolean(touched.password && errors.password)}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      style: {
                        textTransform: "none"
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Alterar visibilidade da senha"
                            onClick={() =>
                              setShowCurrentPassword(!showCurrentPassword)
                            }
                            onMouseDown={e => e.preventDefault()}
                            edge="end"
                          >
                            {showCurrentPassword ? (
                              <VisibilityOffOutlined />
                            ) : (
                              <VisibilityOutlined />
                            )}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </div>

                <div className="xv-password-form__field">
                  <TextField
                    type={showNewPassword ? "text" : "password"}
                    variant="outlined"
                    fullWidth
                    label="Nova Senha"
                    className="kt-width-full input-modal-update-password"
                    name="newPassword"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.newPassword}
                    helperText={touched.newPassword && errors.newPassword}
                    error={Boolean(touched.newPassword && errors.newPassword)}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      style: {
                        textTransform: "none"
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Alterar visibilidade da senha"
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            onMouseDown={e => e.preventDefault()}
                            edge="end"
                          >
                            {showNewPassword ? (
                              <VisibilityOffOutlined />
                            ) : (
                              <VisibilityOutlined />
                            )}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </div>

                <div className="xv-password-form__field">
                  <TextField
                    type={showConfirmPassword ? "text" : "password"}
                    variant="outlined"
                    fullWidth
                    label="Confirme a Senha"
                    className="kt-width-full input-modal-update-password"
                    name="confirmPassword"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.confirmPassword}
                    helperText={
                      touched.confirmPassword && errors.confirmPassword
                    }
                    error={Boolean(
                      touched.confirmPassword && errors.confirmPassword
                    )}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      style: {
                        textTransform: "none"
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Alterar visibilidade da senha"
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                            onMouseDown={e => e.preventDefault()}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOffOutlined />
                            ) : (
                              <VisibilityOutlined />
                            )}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </div>
                <div className="xv-password-form__actions">
                  <button
                    onClick={() => setOpen(false)}
                    type="button"
                    className="cancel"
                  >
                    <FiArrowLeft /> Cancelar
                  </button>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="submit primary"
                  >
                    Alterar
                    <FiArrowRight />
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </StyledModal>
  );
}

export default injectIntl(connect(null, auth.actions)(ModalAlterPassword));
